export enum CouponType {
  Amount = 'AMOUNT',
  FreeSample = 'FREE_SAMPLE',
  FreeShipping = 'FREE_SHIPPING',
  GiftCertificate = 'GIFT_CERTIFICATE',
  PercentOff = 'PERCENT_OFF',
  VariablePercentOff = 'VARIABLE_PERCENT_OFF',
}

export enum MessageSeverity {
  Error = 'ERROR',
  Information = 'INFORMATION',
  Success = 'SUCCESS',
  Warning = 'WARNING',
}

export enum MessageType {
  DiscountShipping = 'DISCOUNT_SHIPPING',
  DiscountSitewide = 'DISCOUNT_SITEWIDE',
  DiscountVolume = 'DISCOUNT_VOLUME',
  ExpiredProductRemoval = 'EXPIRED_PRODUCT_REMOVAL',
  FlatRateShippingApplied = 'FLAT_RATE_SHIPPING_APPLIED',
  FreeShippingOnProductApplied = 'FREE_SHIPPING_ON_PRODUCT_APPLIED',
  NonsaleableProductRemoval = 'NONSALEABLE_PRODUCT_REMOVAL',
  ProductWarning = 'PRODUCT_WARNING',
}

export enum ShippingMethod {
  Express = 'EXPRESS',
  Standard = 'STANDARD',
}

export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  code: string;
  discount: Price;
  displayName: string;
  expiryDate: string;
  type: CouponType;
};

export type Cart = {
  __typename?: 'Cart';
  appliedCoupon?: AppliedCoupon | null;
  lineItems: LineItem[];
  messages: Message[];
  summary: Summary;
};

export type CartUserError = UserError & {
  __typename?: 'CartUserError';
  code: string | number;
  field: string[];
  message?: string | null;
  messageParams?: Record<string, string>;
};

export type Details = {
  __typename?: 'Details';
  blankItemId?: string | null;
  imageUrl?: string | null;
  inventoryItemId?: string | null;
  marketingProductTypeId?: string | null;
  marketingSku?: string | null;
  options?: string | null;
  price?: Price | null;
  productTypeId?: string | null;
  productUrl?: string | null;
  type?: string | null;
};

export type EstimatedShipping = {
  __typename?: 'EstimatedShipping';
  express?: PriceWithTax | null;
  standard: PriceWithTax;
};

export type LineItem = {
  __typename?: 'LineItem';
  details: Details;
  gaCode?: string | null;
  id: string;
  isDigital?: boolean | null;
  isQuantityEditable?: boolean | null;
  quantity: number;
  total?: Price | null;
  totalShipping?: Price | null;
  undiscountedTotal?: Price | null;
  work?: Work | null;
};

export type Message = {
  __typename?: 'Message';
  actionUrl?: string | null;
  applied: boolean;
  productName?: string | null;
  severity: MessageSeverity;
  text?: string | null;
  type: MessageType;
};

export type Price = {
  __typename?: 'Price';
  amount: number;
  currency: string;
};

export type PriceWithTax = {
  __typename?: 'PriceWithTax';
  amountExTax: number;
  price: Price;
  tax: Tax;
};

export type Shipping = {
  __typename?: 'Shipping';
  countryCode: string;
  countryName: string;
  estimated: EstimatedShipping;
  selected: ShippingSelected;
  totals: Totals;
};

export type ShippingSelected = {
  __typename?: 'ShippingSelected';
  estimatedCost: PriceWithTax;
  method: ShippingMethod;
};

export type Summary = {
  __typename?: 'Summary';
  digitalProductsOnly: boolean;
  lineItemsCount: number;
  shipping: Shipping;
  showTaxSeparately: boolean;
  subtotal: Price;
  tax?: Tax | null;
  total: Price;
  undiscountedSubtotal: Price;
  isTaxComputed: boolean;
};

export type Tax = {
  __typename?: 'Tax';
  amount: number;
  currency: string;
  type: string;
};

export type Totals = {
  __typename?: 'Totals';
  express?: Price | null;
  standard: Price;
};

export type UpdateLineItemResult = {
  __typename?: 'UpdateLineItemResult';
  cart?: Cart | null;
  cartUserError: CartUserError | null;
};

export type UserError = {
  code: string | number;
  field: string[];
};

export type Work = {
  __typename?: 'Work';
  artistName?: string | null;
  id: string;
  title?: string | null;
};
